module.exports = __webpack_public_path__ + "img/default-ssch.bf2cc086.jpg";